import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        find(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/referrals/${id}`)
                    .then((res) => {
                        resolve(res.data.data.appointment_referral);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/medico/referrals", data, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((res) => {
                        resolve(res.data.data.appointment_referral);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update(_, formData) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/medico/referrals/${formData.get("id")}`, formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((res) => {
                        resolve(res.data.data.appointment_referral);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete(_, appointmentReferralId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/medico/referrals/${appointmentReferralId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore(_, appointmentReferralId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/medico/referrals/${appointmentReferralId}/restore`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getTypes() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/medico/referrals/types")
                    .then((res) => {
                        resolve(res.data.data.types);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getPriorities() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/medico/referrals/priorities")
                    .then((res) => {
                        resolve(res.data.data.priorities);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getStatuses() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/medico/referrals/statuses")
                    .then((res) => {
                        resolve(res.data.data.statuses);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        downloadReport({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/referrals/${id}/report`, {
                        responseType: "blob",
                    })
                    .then((response) => {
                        let fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        let fileLink = document.createElement("a");
                        fileLink.href = fileURL;
                        fileLink.setAttribute(
                            "download",
                            `referral-${id}.pdf`
                        );
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        document.body.removeChild(fileLink);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        downloadXml({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/medico/referrals/${id}/xml`, {
                        responseType: "blob",
                    })
                    .then((response) => {
                        let fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        let fileLink = document.createElement("a");
                        fileLink.href = fileURL;
                        fileLink.setAttribute(
                            "download",
                            `referral-${id}.xml`
                        );
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        document.body.removeChild(fileLink);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
